import { Pagination, Space, Table, Tag, Tooltip } from "antd";
import type { ColumnsType } from "antd/es/table";
import { BiShow } from "react-icons/bi";
import { MdAttachFile } from "react-icons/md";
import moment from "moment";

const STATUS_COLORS: Record<string, string> = {
  pending: "default",
  sending: "blue",
  completed: "green",
  partial: "orange",
  failed: "red",
};

function DataTable(props: any) {
  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      width: 60,
      render: (_text: any, _record: any, index: number) => (
        <div>{(props?.page - 1) * props?.pagesize + index + 1}</div>
      ),
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      width: 320,
      render: (text: string, record: any) => (
        <div
          style={{ cursor: "pointer", fontWeight: 500 }}
          onClick={() => props.onView(record)}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Audience",
      dataIndex: "recipient_type",
      key: "recipient_type",
      width: 120,
      render: (text: string) => (
        <Tag color={text === "all" ? "blue" : "purple"}>
          {text === "all" ? "All Users" : "Epaper Users"}
        </Tag>
      ),
    },
    {
      title: "Recipients",
      dataIndex: "email_count",
      key: "email_count",
      width: 110,
      render: (count: number) => <Tag>{count || 0}</Tag>,
    },
    {
      title: "Sent",
      dataIndex: "sent_count",
      key: "sent_count",
      width: 90,
      render: (count: number) => (
        <span style={{ color: "#16a34a", fontWeight: 500 }}>{count || 0}</span>
      ),
    },
    {
      title: "Failed",
      dataIndex: "failed_count",
      key: "failed_count",
      width: 90,
      render: (count: number) => (
        <span style={{ color: count > 0 ? "#dc2626" : "#666" }}>
          {count || 0}
        </span>
      ),
    },
    {
      title: "Attachment",
      dataIndex: "attachment_name",
      key: "attachment_name",
      width: 140,
      render: (name: string) =>
        name ? (
          <Tooltip title={name}>
            <Tag icon={<MdAttachFile />} color="geekblue">
              {name.length > 14 ? `${name.slice(0, 12)}...` : name}
            </Tag>
          </Tooltip>
        ) : (
          <span style={{ color: "#999" }}>—</span>
        ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 110,
      render: (status: string) => (
        <Tag color={STATUS_COLORS[status] || "default"}>
          {status ? status.toUpperCase() : "-"}
        </Tag>
      ),
    },
    {
      title: "Sent By",
      dataIndex: "sent_by",
      key: "sent_by",
      width: 160,
      render: (val: string) => val || "—",
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 160,
      render: (val: string) =>
        val ? moment(val).format("DD MMM YYYY, hh:mm A") : "-",
    },
    {
      title: "Action",
      key: "action",
      width: 90,
      fixed: "right" as const,
      render: (_: any, record: any) => (
        <Space size="middle">
          <Tooltip title="View Details">
            <BiShow
              size={20}
              color="#0055a6"
              cursor="pointer"
              onClick={() => props.onView(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ marginTop: 10 }}>
      <Table
        columns={columns}
        dataSource={props.data}
        pagination={false}
        size="small"
        rowKey="id"
        scroll={{ x: "max-content" }}
      />
      <br />
      <div style={{ float: "right" }}>
        <Pagination
          responsive
          current={Number(props?.page) || 1}
          total={props?.meta || 0}
          pageSize={Number(props?.pagesize) || 10}
          onChange={(p, t) => props.onPageChange(p, t)}
        />
      </div>
    </div>
  );
}

export default DataTable;
